import React from 'react'
import styled from 'styled-components'

const StyledSVG = styled.svg`
`

const MenuCloseIcon = () => {
  return (
    <StyledSVG
    width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">  
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.55649 9.97056L0.778315 17.7487L2.19253 19.163L9.9707 11.3848L17.7489 19.163L19.1631 17.7487L11.3849 9.97056L19.1631 2.19239L17.7489 0.778174L9.9707 8.55635L2.19253 0.778174L0.778315 2.19239L8.55649 9.97056Z" fill="#475468"/>
    </StyledSVG>
  )
}

export default MenuCloseIcon
